import { MutationOptions, useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"

interface Args {
  projectSectionId: string
  projectSectionPosition: number
  taskId: string
}

interface Params {
  projectId: string
}

export function useUpdateTaskPositionMutation(params: Params, options?: MutationOptions<any,any,any>) {
  const {
    projectId,
  } = params

  const apiClient = useApiClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["update-task-position"],
    async (args: Args) => {
      const { projectSectionPosition, projectSectionId, taskId } = args

      const response = await apiClient.updateTasksWithDifferentSections(
        projectId,
        projectSectionId,
        projectSectionPosition,
        taskId,
      )

      if (!response.ok) {
        throw response.errors
      }

      return { task: response, params: params }
    },
    options
  )

  return mutation
}